'use client';

import { Moon, Sun } from 'lucide-react';
import { useTheme } from 'next-themes';

import { m } from '@/paraglide/messages.js';
import { Button } from '@/components/ui/button';

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  return (
    <Button
      variant="ghost"
      size="icon"
      className="size-10"
      onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
    >
      <Sun className="size-4 dark:hidden" />
      <Moon className="hidden size-4 dark:block" />
      <span className="sr-only">{m['common.theme.toggle']()}</span>
    </Button>
  );
}
